import React, { Fragment, useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import AuthorizationComponent from "../components/Authorization/AuthorizationComponent";
import { PageWrapper } from "../components/PageWrapper/PageWrapper";
import { Header } from "../components/Layout/Header/Header";
import { Safearea } from "../components/UI/Safearea/Safearea";

export const Authorizations = () => {
  return (
    <Fragment>
      <Header title="Autorizaciones" />
      <Safearea>
        <AuthorizationComponent />
      </Safearea>
    </Fragment>
  );
};
